<template>
  <div class="Rotation">
    <!-- 翻页按钮 -->
    <div class="lower">
      <div style="width: 30px;height: 30px;"></div>
      <div style="display: flex;font-size: 22px;text-align: center;line-height: 30px;">
        <div :class="[carouseVal==0?'bck1':'bck2']" class="content_btn" @click="arrowClick('left')">上一页
        </div>
        <div :class="[carouseVal==(internal_goods_tableData.length-1)?'bck1':'bck2']" class="content_btn" @click="arrowClick('right')">下一页
        </div>
      </div>
    </div>
    <!-- 商品轮播图 商品列表 -->
    <el-carousel trigger="click" height="425px" style="background-color: rgb(208, 233, 247);" arrow="never"
      ref="cardShow" @change="carouseChange" :loop="false" :autoplay="false">
      <el-carousel-item v-for="(val, i) in internal_goods_tableData.length" :key="i">
        <div class="card_box">
          <Card v-for="(item, i) in internal_goods_tableData[i]" :key="i" :item="item" :i="i"
            style="margin:0 10px 10px ;" @qr_code_but="qr_code_but" @commodity_payment="commodity_payment"
            @phone_but="phone_but"></Card>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  import Card from './card.vue';
  export default {
    name: "Rotation",
    data() {
      return {
        carouseVal: 0
      }
    },
    components: {
      Card
    },
    inject: ["qr_code_but", "phone_but", "commodity_payment"],
    props: ['internal_goods_tableData'],
    created() {

    },
    methods: {
      arrowClick(val) {
        if (val === 'right') {
          this.$refs.cardShow.next()
        } else {
          this.$refs.cardShow.prev()
        }
      },
      carouseChange(val) {
        this.carouseVal = val
      }
    }
  }
</script>

<style scoped>
  .content_btn {
    width: 110px;
    height: 30px;
    margin-left: 10px;
    border-radius: 6px;
    color: #fff;
  }


  .lower {
    width: 1000px;
    height: 60px;
    padding: 10px 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }


  .card_box {
    width: 960px;
    height: 350px;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    background-color: rgb(208, 233, 247);
    border: none;
  }

  .Rotation /deep/ .el-carousel__indicators {
    display: block;
  }

  .Rotation /deep/ .el-carousel__indicators--horizontal {
    bottom: 16px;
  }

  .bck1 {
    border: 1px solid rgb(255, 134, 85);
    color: rgb(255, 134, 85);
  }

  .bck2 {
    background-color: rgb(255, 134, 85);
  }
</style>


// WEBPACK FOOTER //
// src/components/views/components/Rotation.vue